module.exports = "/images/aerial-1.jpg";